export default __webpack_public_path__ + "static/media/fw-elizabeth-er-White Gold.39041a04.mp4";